import type { QueryParams } from '~/types/api'
import type { ContactSalesman, ContactSalesmenPagedResult } from '~/types/api'

function getSalesmanFilter(contactSectionNid: number) {
  return [
    {
      [APIFilterOP.EQUALS]: {
        'contactSections.nid': contactSectionNid,
      },
    },
    {
      [APIFilterOP.EQUALS]: {
        status: 1,
      },
    },
  ]
}

export function createContactSalesmenRepository() {
  const { $api } = useNuxtApp()
  const { get } = baseRepository($api)

  const DOMAIN = 'contact-salesmen'

  async function getAll(params?: QueryParams) {
    return get<ContactSalesmenPagedResult>([DOMAIN], { params })
  }

  async function getAllBySectionNid(nid: number) {
    const params = {
      filter: APIFilters.makeFilter(getSalesmanFilter(nid)),
      sort: APIFilters.makeSort({ weight: 'ASC' }),
    }

    return get<ContactSalesmenPagedResult>([DOMAIN], { params })
  }

  async function getByNid(nid: number) {
    return get<ContactSalesman>([DOMAIN, nid.toString()])
  }

  return {
    getAll,
    getByNid,
    getAllBySectionNid,
  }
}
